module.exports = __webpack_public_path__ + "img/40ne.88f9d319.svg";